<template>
  <div id="sundry-item-order-details-view" class="vx-row" >
    <div class="vx-col w-full">
      <vx-card v-if="dataLoaded" :title="orderDetails.sundry_order_code">
        <template slot="actions">
          <div class="flex">
            <!-- <div class="flex">
              <vs-button  @click="onClickPoPdf()" class="ml-2" color="dark" type="border" >Purchase Order PDF</vs-button>
              <vx-tooltip class="ml-2" text="View Sent PDF Log" position="top">
                <vs-button @click.stop="viewSendEmailLog()"
                           color="primary" type="border" icon-pack="feather" icon="icon-book"></vs-button>
              </vx-tooltip>
              <vx-tooltip class="ml-2" text="Update Order Details & Additional Cost" position="top">
                <vs-button @click.stop="onClickUpdateOrderDetails()"
                           color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
              </vx-tooltip>
              <vs-button  @click="onClickBack" class="ml-2" color="primary" type="filled">Back to orders</vs-button>
            </div> -->
          </div>
          <div class="flex">
            <vs-dropdown>

                <a class="flex items-center" href="#">
                  <i class="material-icons"> menu </i>
                </a>

                <vs-dropdown-menu class="w-64">

                  <vs-dropdown-item
                    @click="onClickPoPdf()">
                    Purchase Order PDF
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="viewSendEmailLog()">
                    View Sent PDF Log
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="onClickUpdateOrderDetails()">
                    Update Order Details & Additional Cost
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-can="'create-edit-sundry-orders'"
                    @click="onClickSundryOrderUpdate('items')">
                    Update Items
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="onClickBack">
                    Back to orders
                  </vs-dropdown-item>

                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
        </template>

        <div class="vx-row md:mb-3 mt-8">
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Supplier</h5>
                    <HyperLink :id="orderDetails.sundry_supplier_id" type="sundry_supplier">{{ orderDetails.sundry_supplier}}</HyperLink>, <br>
                    {{orderDetails.sundry_supplier_address.line1}} <br v-if="orderDetails.sundry_supplier_address.line1">
                    {{orderDetails.sundry_supplier_address.line2}} <br v-if="orderDetails.sundry_supplier_address.line2">
                    {{orderDetails.sundry_supplier_address.line3}} <br v-if="orderDetails.sundry_supplier_address.line3">
                    {{orderDetails.sundry_supplier_address.town_state}} <br>
                    {{orderDetails.sundry_supplier_address.post_code}} <br>
                    {{orderDetails.sundry_supplier_address.country}} <br>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserCheckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Ordered By</h5>
                    {{orderDetails.staff}}
                  </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Order Date</h5>
                    {{__dateTimeFormatter(orderDetails.created_at)}}
                  </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Required By Date</h5>
                    {{orderDetails.required_by || 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Notes</h5>
                    {{orderDetails.note || 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
<!--          <div class="vx-col md:w-1/4 w-full">-->
<!--            <vs-row vs-type="flex">-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">-->
<!--                <feather-icon icon="RefreshCwIcon" class="text-success cursor-pointer"/>-->
<!--              </vs-col>-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">-->
<!--                  <span class="text-md break-all">-->
<!--                    <h5 class="mb-2">Order Status</h5>-->
<!--                    <vs-chip style="border-radius: 0" class="text-center"-->
<!--                             transparent-->
<!--                             :color="orderDetails.is_item_status_handled_individually ? 'dark' : sundryOrderStatusColorFactory()">-->
<!--                        {{ orderDetails.is_item_status_handled_individually ? 'PO Ungrouped' : orderDetails.status.name }}-->
<!--                      </vs-chip>-->
<!--                  </span>-->
<!--              </vs-col>-->
<!--            </vs-row>-->
<!--          </div>-->
        </div>
        <div class="vx-row md:mb-3 mt-16">
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="MapPinIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Address</h5>
                    {{orderDetails.line1}} <br v-if="orderDetails.line1">
                    {{orderDetails.line2}} <br v-if="orderDetails.line2">
                    {{orderDetails.line3}} <br v-if="orderDetails.line3">
                    {{orderDetails.town_state}} <br>
                    {{orderDetails.post_code}} <br>
                    {{orderDetails.country}} <br>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="TruckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Delivery Instructions</h5>
                    {{orderDetails.delivery_instruction || 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <!-- <div class="vx-col md:w-1/4 w-full">
          <vs-row vs-type="flex">
            <vs-col
              vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
              <feather-icon icon="CreditCardIcon" class="text-success cursor-pointer"/>
            </vs-col>
            <vs-col
              vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Payment Status</h5>
                    <v-select :clearable="false"
                              :options="payment_status"
                              v-model="orderDetails.payment_status"
                              @input="openPaymentStatusChangeConfirm()"
                              :reduce = "option => option.value"
                              label="name"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                  </span>
            </vs-col>
          </vs-row>
        </div> -->

          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="File" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Order Documents</h5>
<!--                    <vs-button @click="openFileUploadPopUp" size="small" color="success" type="filled" icon-pack="feather"-->
<!--                               icon="icon-plus" v-if="sundryDocuments.length === 0">Add Invoice File</vs-button>-->
                    <vs-button @click="openInvoiceDocument" size="small" color="success" type="filled" icon-pack="feather"
                               icon="icon-eye">View Documents</vs-button>
                  </span>
              </vs-col>
            </vs-row>
          </div>
<!--          <div v-can="'create-edit-sundry-orders'" class="vx-col md:w-1/4 w-full" v-if="orderDetails.sundry_items.length > 1">-->
<!--            <vs-row vs-type="flex">-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">-->
<!--                <feather-icon icon="SettingsIcon" class="text-success cursor-pointer"/>-->
<!--              </vs-col>-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">-->
<!--                  <span class="text-md break-word">-->
<!--                    <h5 class="mb-2">Do you want to handle each item on this order independently? <br>-->
<!--                    <span class="text-danger text-sm">( If not this <span class="font-bold">PO</span> will be process as a multi-product batch )</span></h5>-->
<!--                    <vs-switch :disabled="orderDetails.sundry_items.length === 1" v-on:input="onChangeOrderStatusHandle()" v-model="orderDetails.is_item_status_handled_individually" />-->
<!--                  </span>-->
<!--              </vs-col>-->
<!--            </vs-row>-->
<!--          </div>-->

        </div>

<!--        <div v-can="'create-edit-sundry-orders'" class="vx-row" v-if="!orderDetails.is_item_status_handled_individually">-->
<!--          <div class="vx-col w-full">-->
<!--            <div class="flex float-right">-->
<!--              <vs-dropdown>-->

<!--                <a class="flex items-center" href="#">-->
<!--                  Order Status-->
<!--                  <i class="material-icons"> expand_more </i>-->
<!--                </a>-->

<!--                <vs-dropdown-menu class="w-64">-->

<!--                  <vs-dropdown-item-->
<!--                    v-for="status in sundry_item_order_statuses"-->
<!--                    v-bind:key="status.slug"-->
<!--                    v-if="(status.before_status.includes(orderDetails.status.name) || orderDetails.sundry_items.map((n) => n.item_status).includes(status.item_status)) && checkIfPartialAndOneItem(status.is_partial_status)"-->
<!--                    @click="onClickStatusChangeConfirm(orderDetails.id, status.slug)">-->
<!--                    {{status.name}}-->
<!--                  </vs-dropdown-item>-->

<!--                </vs-dropdown-menu>-->
<!--              </vs-dropdown>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

      </vx-card>

        <vx-card v-if="dataLoaded" class="mt-8 mb-3" title="Order Items">
          <!-- <template slot="actions">
            <vs-button v-can="'create-edit-sundry-orders'"
                       @click="onClickSundryOrderUpdate('items')"
                       color="warning" type="border" >Update Items</vs-button>
          </template> -->
          <div class="vx-row my-8">
            <div class="vx-col w-full">
              <div class="vx-row my-8">
                <div class="vx-col w-full">
                  <sundry-order-items-table v-bind:id="orderDetails.id" v-bind:items="orderDetails.sundry_items" :sundry_supplier_currency="orderDetails.sundry_supplier_currency"/>
                </div>
              </div>
            </div>
          </div>
      </vx-card>
      <vx-card class="mb-3" title="Additional cost" v-if="dataLoaded">
        <div class="vx-row mb-4">
          <div class="w-full vx-col md:w-2/3 md:mb-0">
            <vs-table :data="orderDetails.additional_cost">

              <template slot="thead">
                <vs-th width="30%">Details</vs-th>
                <vs-th width="30%">Value (GBP)</vs-th>
              </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="index_item" v-for="(tr_item, index_item) in data">

                      <vs-td :data="tr_item.name">
                        {{ tr_item.name }}
                      </vs-td>

                      <vs-td :data="tr_item.amount">
                        {{ tr_item.amount }}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
      </vx-card>
    </div>
    <update-sundry-order-pop-up ref="updateSundryOrderPopUp"/>
    <sundry-item-purchase-order-pdf-pop-up ref="sundryItemPurchaseOrderPdfPopUp"/>
    <add-sundry-item-invoice-file-pop-up ref="addSundryItemInvoiceFilePopUp"/>
    <view-sundry-item-invoice-list-pop-up ref="viewSundryItemInvoiceListPopUp"/>
    <sundry-order-invoice-email-log-pop-up ref="sundryOrderInvoiceEmailLogPopUp"/>
    <update-sundry-item-order-details-popup ref="UpdateSundryItemOrderDetailsPopup" />
  </div>
</template>

<script>
  import SundryOrderItemsTable from "./SundryOrderItemsTable";
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SundrySupplierRepository = RepositoryFactory.get('sundry')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {sundry_item_order_statuses} from '@/constants/statuses'
  import UpdateSundryOrderPopUp from "@/components/popups/sundry-suppliers/sundry-item-orders/UpdateSundryOrderPopUp";
  import SundryItemPurchaseOrderPdfPopUp
    from "@/components/popups/sundry-suppliers/sundry-item-orders/SundryItemPurchaseOrderPdfPopUp";
  import vSelect from "vue-select";
  import AddSundryItemInvoiceFilePopUp from "@/components/popups/sundry-item-orders/AddSundryItemInvoiceFilePopUp";
  import ViewSundryItemInvoiceListPopUp
    from "../../../../components/popups/sundry-item-orders/ViewSundryItemInvoiceListPopUp";
  import SundryOrderInvoiceEmailLogPopUp
    from "@/components/popups/sundry-suppliers/sundry-item-orders/SundryOrderInvoiceEmailLogPopUp";
  import UpdateSundryItemOrderDetailsPopup
    from "@/components/popups/sundry-suppliers/sundry-item-orders/UpdateSundryItemOrderDetailsPopup";

  export default {
    name: "RmOrderDetailsView",
    components: {
      ViewSundryItemInvoiceListPopUp,
      AddSundryItemInvoiceFilePopUp,
      SundryOrderItemsTable,
      UpdateSundryOrderPopUp,
      SundryItemPurchaseOrderPdfPopUp,
      SundryOrderInvoiceEmailLogPopUp,
      UpdateSundryItemOrderDetailsPopup,
      'v-select': vSelect,
    },
    data: function() {
      return {
        orderDetails: {
          additional_cost: [],
          sundry_supplier_address: {
            line1: '',
            line2: '',
            line3: '',
            post_code: '',
            town_state: '',
            country: ''
          }
        },
        id: '',
        dataLoaded: false,
        sundry_item_order_statuses: sundry_item_order_statuses,
        payment_status:[
          {name: 'Pre Invoice', value: 'pre-invoice'},
          {name: 'Paid', value: 'paid'},
          {name: 'GRNI', value: 'grni'}
        ],
        sundryDocuments:{}
      }
    },
    mixins : [ SuccessMessage, ErrorMessages],
    async mounted() {
      this.id = this.$route.params.id
      await this.getSundryItemOrderDetails()
      await this.getSundryItemDocuments()
    },
    methods: {
      async refreshData() {
        await this.getSundryItemOrderDetails()
      },
      onClickBack() {
        this.$router.push({path: `/pages/sundry-items?step=1`})
      },
      async onClickStatusChangeConfirm(id, status, items) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeSundryItemOrderStatus,
          parameters: [id, status]
        })
      },

      openPaymentStatusChangeConfirm(){
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to change payment status?',
          accept: this.onClickChangePaymentStatus,
        })
      },

      async onClickChangePaymentStatus(){
        await this.$vs.loading()
        try {
          const status = this.orderDetails.payment_status
          await SundrySupplierRepository.changeSundryItemOrderStatus(this.orderDetails.id, status)
          await this.refreshData()
          this.showSuccessMessage('Status change successfully!')
        }catch (error){
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close()
      },
      async onChangeSundryItemOrderStatus(params){
        await this.$vs.loading({
          container: '#sundry-item-order-details-view',
          scale: 0.45
        })
        try {
          await SundrySupplierRepository.changeSundryItemOrderStatus(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.getSundryItemOrderDetails()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#sundry-item-order-details-view > .con-vs-loading')
      },
      async getSundryItemOrderDetails() {
        await this.$vs.loading({
          container: '#sundry-item-order-details-view',
          scale: 0.45
        })
        try {
          const {data} = (await SundrySupplierRepository.getSundryOrder(this.id)).data
          this.orderDetails = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#sundry-item-order-details-view > .con-vs-loading')
        this.dataLoaded= true
      },
      async getSundryItemDocuments(){
        const {data} = await SundrySupplierRepository.getSundryItemDocuments(this.id)
        this.sundryDocuments =  data.data.filter((invoice) => invoice.type === 'invoice' )
      },
      async openFileUploadPopUp(){
        await this.$refs.addSundryItemInvoiceFilePopUp.openPopup(this.id)
      },
      async openInvoiceDocument(){
        await this.$refs.viewSundryItemInvoiceListPopUp.openPopup(this.id)
      },
      async getProductOrderList() {
        await this.getSundryItemOrderDetails()
      },
      async onClickSundryOrderUpdate() {
        await this.$refs.updateSundryOrderPopUp.openPopup(this.id)
      },
      /**
       * @return {string}
       */
      sundryOrderStatusColorFactory() {
        const colors = {
          1: '#f8961e',
          2: '#f9844a',
          3: '#f9c74f',
          4: '#43aa8b',
          5: '#219ebc',
          6: '#006d77',
          7: '#d62828',
          8: '#4895ef',
          9: '#3a0ca3',
          10: '#52b788',
          11: '#f72585'
        }
        return colors[this.orderDetails.status.id]
      },
      async onChangeOrderStatusHandle () {
        await this.$vs.loading({
          container: '#sundry-item-order-details-view',
          scale: 0.45
        })
        try {
          await SundrySupplierRepository.changeSundryOrderHandleType(this.id)
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#sundry-item-order-details-view > .con-vs-loading')
      },
      checkIfPartialAndOneItem(is_partial_status) {
        return !(is_partial_status && this.orderDetails.sundry_items.length === 1)
      },
      async onClickPoPdf() {
        let routeData = this.$router.resolve({name:'sundry-item-order-print-view', params:{id:this.id}})
        window.open(routeData.href,'_blank');
      },
      async viewSendEmailLog() {
        this.$refs.sundryOrderInvoiceEmailLogPopUp.openPopUp(this.id)
      },
      async onClickUpdateOrderDetails() {
        await this.$refs.UpdateSundryItemOrderDetailsPopup.openPopup(this.id)
      }
    }
  }
</script>
